import React, {useState} from "react";
import {DatePicker, Space} from "antd";
import {CaretDownFilled} from "@ant-design/icons";
import FilterBullet from "../../../helpers/components/filter_bullet";
import dayjs from "dayjs";

const {RangePicker} = DatePicker;

const DatePickerFilter = ({filter = {}, changeDate,}) => {
    return (
        <>
            <FilterBullet
                popover={
                    <>
                        <div>
                            <RangePicker
                                {...(filter?.start_date && filter?.end_date) && ({defaultValue: [dayjs(filter?.start_date), dayjs(filter?.end_date)]})}
                                // disabled={ticketRedux?.list_loading}
                                onChange={(e) => changeDate('start_date', 'end_date', e)} format={"YYYY-MM-DD"}
                            />
                        </div>
                    </>
                }
            >
                <div>
                    <Space>
                        <div>
                            <span>Date
                                <span style={{
                                    fontSize: 12,
                                    fontWeight: 500,
                                    color: 'var(--secondary-text-color)'
                                }}>
                                    {filter?.start_date && filter?.end_date && `: ${filter?.start_date}-${filter?.end_date}`}
                                </span>
                            </span>
                        </div>
                        <div>
                            <CaretDownFilled style={{color: '#a0aec0'}}/>
                        </div>
                    </Space>
                </div>
            </FilterBullet>
        </>
    );
};

export default DatePickerFilter;
